import { render, staticRenderFns } from "./DayDropdown.vue?vue&type=template&id=22639196&"
import script from "./DayDropdown.vue?vue&type=script&lang=js&"
export * from "./DayDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports